'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'plane';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f072';
var svgPathData = ['M55.9 161.6l23.5 88.2 1.6 6.2-1.6 6.2-23.5 88.2 55.4-55.4 7-7 377.9 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-377.9 0-7-7-55.4-55.4zM185.5 48l42.7 128 102.8 0-117.3-128-28.1 0zm0 416l35.8 0 112-128-105.1 0-42.7 128z', 'M576.2 256c0-44.2-35.8-80-80-80L396.1 176 241.9 7.8 234.8 0 118.9 0c.8 2.3 20.3 60.9 58.7 176l-39.4 0-57-57-7-7-81.2 0c1.6 6.2 14.5 54.2 38.4 144-24 89.8-36.8 137.8-38.4 144l81.2 0 7-7 57-57 39.4 0c-38.4 115.1-57.9 173.7-58.7 176l124.2 0 7.2-8.2 146.8-167.8 99.1 0c44.2 0 80-35.8 80-80zm-80-32c17.7 0 32 14.3 32 32s-14.3 32-32 32l-377.9 0-7 7-55.4 55.4 23.5-88.2 1.6-6.2-1.6-6.2-23.5-88.2 55.4 55.4 7 7 377.9 0zM331 176l-102.8 0-42.7-128 28.1 0 117.3 128zM228.2 336l105.1 0-112 128-35.8 0 42.7-128z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPlane = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;